<div class="tw-border tw-border-solid tw-border-red-600 tw-bg-red-200 tw-font-strong tw-text-red-600 tw-p-6 tw-mb-6">
  {{ 'monitoring.deprecatedMonitorText.part1' | translate }}
  {{ 'monitoring.deprecatedMonitorText.part2' | translate }}
  <a [routerLink]="'/dashboard/monitoring/shipments/list'" class="tw-underline">{{
    'monitoring.deprecatedMonitorText.part3' | translate
  }}</a
  >.
  {{ 'monitoring.deprecatedMonitorText.part4' | translate }}
</div>
